<div class="switch">
  <label [class.center-label]="centerLabel">
    <ng-container *ngIf="!!leftLabel"
      ><span [class]="labelClass">{{ leftLabel }}</span></ng-container
    >
    <span class="checkbox cx-visually-hidden">
      <ng-content select="input[type=checkbox]"></ng-content>
    </span>
    <span class="lever flex-shrink-0" [ngClass]="{ 'add-margin': addMargin, 'right-margin': rightMargin }"></span>
    <ng-container *ngIf="!!rightLabel">
      <span [class]="labelClass">{{ rightLabel }}</span>
    </ng-container>
  </label>
  <i *ngIf="!!tooltip" nz-icon nzType="question-circle" [ngbTooltip]="tooltip" class="ml-2"></i>
</div>
